module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-inc.7e05124dad0248f3dfed4d7993bb6f93.png";